export default "assets/lines-dark-55e625e2.svg";